import React from "react";
import { useState, useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import "./login.css";
import { GET_API_LOGIN, KERN_GETROW, fExecuteAPI } from "../../Server/Apis";
import { httpRequest } from "../../Server/Axios";
import { loginSuccess, loginUserRights } from "./sliceUsers";
import { GrnConfiguration_Set } from "../Grn/SliceGRNConfiguration";
import { GrnLocationGroup_Set } from "../../DBSlice/SliceGRNLocationGroup";
import { GrnLocation_Set } from "../../DBSlice/SliceGRNLocation";
import { GrnTax_Set, PriceLevel_Set } from "../../DBSlice/SliceTax";
import { Bin_WMBin } from "../../DBSlice/SliceBin";
import { GrnBinTransferReason_Set } from "../../DBSlice/SliceGRNBinTransferReason";
import { getGeoLocation } from "../../Server/Axios";
import {
  DB_Kern_Set,
  DB_menus_Set,
  DB_routes_Set,
  DB_BranchList_Set,
  DB_RoundingDigit_Set,
  SUBKONTE,
  Division_Set,
  Location_Set,
  DB_Data_Set,
  DB_Kern_DBKernObj_Set,
  SET_LPO_GROUP,
  SET_APPS,
  SET_Currency,
} from "../../DBSlice/SliceDB";
import { GET_API_LOGINAttribute } from "../../Server/ApiV2";
import { clearSlice } from "../Layout/layoutAction";
import { Navigate, useNavigate } from "react-router-dom";
const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [sErrorMessages, setErrorMessages] = useState({});

  const useRefUserName = useRef(null);
  const useRefPassword = useRef(null);
  // const useRefGroup = useRef(null);
  const errors = {
    error_uname: "Invalid username",
    error_pass: "Invalid password",
    // error_group: "Invalid group",
    error_userid: "Invalid username or password",
    error_msg: "",
  };

  const fLogin = async (event) => {
    var vUName = Boolean(useRefUserName.current.value)
      ? useRefUserName.current.value
      : "";
    var vPassword = Boolean(useRefPassword.current.value)
      ? useRefPassword.current.value
      : "";

    var vIsValid = true;

    setErrorMessages({});

    if (vUName === "") {
      setErrorMessages((messages) => ({
        ...messages,
        uname: errors.error_uname,
      }));
      vIsValid = false;
    }
    if (vPassword === "") {
      setErrorMessages((error) => ({
        ...error,
        pass: errors.error_pass,
      }));
      vIsValid = false;
    }
    if (vIsValid) {
      setErrorMessages({});
      try {
        const resp = await GET_API_LOGINAttribute({
          userId: vUName,
          password: vPassword,
        });
        let vGeoLocation = await getGeoLocation();

        if (resp.status === 200) {
          let {
            login,
            Kern,
            LocationList,
            menus,
            routes,
            UserRights,
            LocWithoutRights,
            LocWithRights,
            Branch,
            WMSPDTUserList,
            Tax,
            Tax2,
            TaxType,
            LocationGroup,
            BinTransferReason,
            WMBin,
            BranchList,
            SUBKONTEN,
            Division,
            Type,
            LPOGruppen,
            Apps,
            Currency
          } = resp?.data?.ResultSet;

          dispatch(
            loginSuccess({
              UserID: login?.Uid,
              UserName: login?.Name1,
              UserGroupCode: login?.Grp,
              UserGroupName: login?.GrpName,
              IP: vGeoLocation || "",
            })
          );

          dispatch(GrnLocation_Set(LocationList));
          dispatch(SET_LPO_GROUP(LPOGruppen));
          dispatch(DB_menus_Set(menus));
          dispatch(DB_routes_Set(routes));
          dispatch(SET_APPS(Apps));
          dispatch(
            loginUserRights({
              UserRights: UserRights[0],
            })
          );
          dispatch(
            Location_Set({
              LocWithoutRights: LocWithoutRights,
              LocWithRights: LocWithRights,
            })
          );
          dispatch(
            DB_Data_Set({
              Branch: Branch,
              WMSPDTUserList: WMSPDTUserList,
            })
          );
          dispatch(GrnConfiguration_Set(Kern));
          dispatch(DB_Kern_Set(Kern));
          const index = Kern.findIndex((o) => o.UId === "WEB_REPORT_BASE_URL");
          const updatedKern = [...Kern]; // clone array
          const currentOrigin = window.location.origin;
          if (index !== -1) {
            const kernObj = { ...updatedKern[index] }; // clone object

            if (currentOrigin === "http://192.168.50.243:3000") {
              kernObj.Val = "http://192.168.50.243:8010/WebReports/";
            }
            if (currentOrigin === "http://sonasgroup.dyndns.org:3050") {
              kernObj.Val = "http://sonasgroup.dyndns.org:8010/webreports/";
            }

            updatedKern[index] = kernObj;
          }
          dispatch(
            DB_Kern_DBKernObj_Set(
              updatedKern.reduce((acc, row) => {
                acc[row.UId] = row;
                return acc;
              }, {})
            )
          );

          const vDIGIT_ROUNDING = Kern?.find((obj) => {
            return obj?.UId === "DIGIT_ROUNDING";
          });

          if (vDIGIT_ROUNDING) {
            dispatch(DB_RoundingDigit_Set(Number(vDIGIT_ROUNDING?.Val)));
          }

          dispatch(
            GrnTax_Set({
              tax1: Tax,
              tax2: Tax2,
            })
          );
          dispatch(PriceLevel_Set(TaxType));
          dispatch(GrnLocationGroup_Set(LocationGroup));
          dispatch(GrnBinTransferReason_Set(BinTransferReason));
          dispatch(Bin_WMBin({ wmBin: WMBin }));
          dispatch(DB_BranchList_Set(BranchList));
          dispatch(SUBKONTE(SUBKONTEN));
          dispatch(Division_Set(Division));
          dispatch(SET_Currency(Currency));
          // <Navigate to="/" />;
          navigate("/");
        } else {
          // setErrorMessages((error) => ({
          //       ...error,
          //       error_msg: Data.Message,
          //     }));
        }
        return;
      } catch (error) {
        console.log(error);
        return;
      }
    }
  };

  const fRenderErrorMessage = (name) =>
    sErrorMessages[name] && (
      <span className="error">{sErrorMessages[name]}</span>
    );

  const fKeyTabLogin = (event, name) => {
    if (event.key === "Enter") {
      if (name === "txtPassword") {
        document.getElementsByName(name)[0]?.focus();
      } else if (name === "login") {
        fLogin();
      }
    }
  };

  useEffect(() => {
    useRefUserName.current?.focus();
    //  clearSlice(dispatch, "");
  }, []);
  return (
    <div className="login-form">
      <form className="login-form-bg" autoComplete="off">
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <div className="logintitle">
                <label>LOGIN</label>
              </div>
              <div className="login-error">
                {fRenderErrorMessage("error_msg")}
              </div>
            </Grid>

            <Grid item xs={3}>
              <div className="login-label">
                <label className=" login-label-font me-3">Username</label>
              </div>
            </Grid>
            <Grid item xs={9}>
              <div className="login-label">
                <input
                  type="text"
                  name="txtUserName"
                  ref={useRefUserName}
                  required
                  className="form-control"
                  onKeyUp={(e) => {
                    fKeyTabLogin(e, "txtPassword");
                  }}
                  autoComplete="off"
                />
              </div>
              <div className="login-error">{fRenderErrorMessage("uname")}</div>
            </Grid>
            <Grid item xs={3}>
              <div className="login-label">
                <label className=" login-label-font  me-3 ">Password</label>
              </div>
            </Grid>
            <Grid item xs={9}>
              <div className="login-label">
                <input
                  type="password"
                  name="txtPassword"
                  ref={useRefPassword}
                  onKeyUp={(e) => {
                    fKeyTabLogin(e, "login");
                  }}
                  className="form-control"
                  required
                  autoComplete="off"
                />
              </div>
              <div className="login-error">{fRenderErrorMessage("pass")}</div>
            </Grid>
            <Grid item xs={12}>
              <div className="login-btn">
                <button
                  type="button"
                  className="btn btn-login px-5 py-2"
                  onClick={(e) => fLogin(e)}
                >
                  Login
                </button>
              </div>
            </Grid>
          </Grid>
        </Box>
      </form>
    </div>
  );
};

export default Login;
